<template>
<!-- 商品管理 -->
    <div class="el-card pd20">
        <div class="main">
            <div class="box">
                <!--  --> 
                <div class="search">
                    <div class="search-gropu">
                        课程名称
                        <el-select class="search-child" @change="courseNameHandle" v-model="course_name" placeholder="请选择课程名称" clearable>
                            <el-option v-for="(item,index) in course_name_list" :key="index"  :label="item.name" :value="item.id">{{item.name}}</el-option>
                        </el-select>
                    </div>
                    <!--  -->
                    <div class="search-gropu">
                        课程期次
                        <el-select class="search-child" @visible-change="courseHandle" v-model="cid" placeholder="请选择课程期次" clearable>
                            <el-option v-for="(item,index) in course_list" :key="index"  :label="item.name" :value="item.id">{{item.name}}</el-option>
                        </el-select>
                    </div>
                    <!--  -->
                    <div class="search-gropu">
                        用户昵称
                        <el-input class="search-child" v-model="nickname" placeholder="请输入用户昵称"></el-input>
                    </div>
                </div>
                
                <!--  -->
                <div class="search search-btn">
                    <!-- 状态 -->
                    <div class="search-gropu">
                        订单状态
                        <el-select class="search-child"  v-model="buystatus" placeholder="请选择订单状态" clearable>
                            <el-option   label="已支付" :value="1">已支付</el-option>
                            <el-option   label="已延期" :value="2">已延期</el-option>
                            <el-option   label="已退费" :value="3">已退费</el-option>
                        </el-select>
                    </div>

                    <!--  -->
                    <div class="search-gropu">
                        转介人昵称
                        <el-input class="search-child" v-model="share_nickname" placeholder="请输入用户昵称"></el-input>
                    </div>

                    <!--  -->
                    <div class="search-gropu">
                        下单时间
                        <el-date-picker class="buy-time" v-model="buy_time" type="daterange"  value-format="yyyy-MM-dd"   start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </div>
                
                <!--  -->
                <div class="search search-btn">
                     <!--  -->
                    <div class="search-gropu">
                        <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
                    </div>
                </div>
            </div>
            <!-- list-->
            <div class="el-card pd20">
                <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="nickname"  label="买家昵称" width="100" ></el-table-column>
                    <el-table-column  label="买家头像" width="80" >
                        <template  slot-scope="scope">
                            <div class="userinfo">
                                <img :src="scope.row.headimgurl" alt="">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="商品名称-期次">
                        <template slot-scope="scope">
                            {{scope.row.bname+' -- '+scope.row.name}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="update_time" label="交易时间" > </el-table-column>
                    <el-table-column  label="订单状态" >
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.buystatus==='已支付'" type="success" size="small" effect="dark">{{scope.row.buystatus}}</el-tag>
                            <el-tag v-else-if="scope.row.buystatus==='已延期'"  type="warning" size="small" effect="dark">{{scope.row.buystatus}}</el-tag>
                            <el-tag v-else-if="scope.row.buystatus==='已退费'"  type="info" size="small" effect="dark">{{scope.row.buystatus}}</el-tag>
                            <el-tag v-else type="danger" size="small" effect="dark">{{scope.row.buystatus}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="extensionTime" label="延期时间" > </el-table-column>
                    <el-table-column prop="extensionName" label="延期期次" > </el-table-column>
                    <el-table-column prop="course_price" label="课程原价" ></el-table-column>
                    <el-table-column prop="price" label="实付金额" ></el-table-column>
                    <el-table-column prop="relation_type" label="订单来源" ></el-table-column>
                    <el-table-column  label="订单备注" >
                        <template slot-scope="scope">
                            <a :class="['note-a',scope.row.remark?'on':'']" @click="doNoteHandle(scope.$index,scope.row,'remark')">{{scope.row.remark?scope.row.remark:'设置备注'}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="brokerage" label="返佣金额" ></el-table-column>
                    <el-table-column prop="shareNickname" label="转介人" ></el-table-column>
                    <el-table-column  label="身份" >
                        <template slot-scope="scope">
                            <a class="note-a" @click="doNoteHandle(scope.$index,scope.row,'shareRemark')">{{scope.row.shareRemark}}</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 添加按钮 -->
            <!-- <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="addGraph" circle></el-button> -->
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
            <!-- -->
            <!-- <div class="pages-box"></div>  -->
        </div>
        <!-- 设置备注弹出框 -->
        <el-dialog title="设置备注" :visible.sync="set_note" width="30%">
            <el-input class="note-input" type="textarea" :rows="2" placeholder="请输入内容" v-model="note"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="set_note = false">取 消</el-button>
                <el-button type="primary" @click="submitNote">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { courseOrderList,remark} from "@/api/operating";
export default {
    data() {
        return{
            list: [],
            pages: {},
            // 下单时间
            buy_time:[],
            nickname:'',
            share_nickname:'',
            course_name:'',
            buystatus:null,
            cid:'',
            obj:{},
            // 课程名称数据
            course_name_list:[],
            // 课程期次数组
            course_list:[],
            // 订单状态
            buystatus_list:[],
            // 设置备注
            set_note:false,
            note:'',
            note_type:'',
            note_obj:{}
        }
    },
    methods:{
        submitNote(){
            this.note_obj['remark'] = this.note;
            remark(this.note_obj).then((data)=>{
                this.set_note = false;
                this.pullData();
            });
        },
        // 设置备注remark
        doNoteHandle(index,row,type){
            // 清空对象
            for(let k of Object.keys(this.note_obj)){
                this.$delete(this.note_obj,k);
            }

            this.note_type = type;
            // 身份
            if(type==='shareRemark'){
                this.note_obj['share_user_id'] = row.share_user_id;
                this.note = row.shareRemark;
            }
            // 订单备注
            if(type==='remark'){
                this.note_obj['id'] = row.id;
                this.note = row.remark;
            }

            this.set_note = true;
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        // 根据选择的课程名称修改期次
        courseNameHandle(){
            for(let key in this.course_name_list){
                if(this.course_name == this.course_name_list[key].id){
                    this.course_list = this.course_name_list[key].course;
                    return
                }
            }
            
        },
        // 判断课程名称是否选择
        courseHandle(val){
            if(val && !this.course_name){
                this.$message({
                    message: '请先选择课程名称！',
                    type: 'warning'
                });
                return;
            }
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };
            // 判断如果有值为真的情况下传参,否则不传
            if(this.cid){
                this.obj['cid'] = this.cid;
            }
            if(this.buystatus){
                this.obj['buystatus'] = this.buystatus;
            }
            if(this.nickname){
                this.obj['nickname'] = this.nickname;
            }
            if(this.share_nickname){
                this.obj['share_nickname'] = this.share_nickname;
            }
            if(this.buy_time && this.buy_time.length>0){
                this.obj['start_time'] = this.buy_time[0];//开始时间
                this.obj['end_time'] = this.buy_time[1];//结束时间
            }
            courseOrderList(this.obj).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;
                // 课程名称
                this.course_name_list = data.course;
                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.preview{
    width: 300px;
    border-radius: 5px;
}
.box{
    margin-bottom: 20px;
}
.search{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.search.search-btn{
    flex: 1;
}
.search-gropu{
    flex: 1;
}
.search-child{
    margin-left: 20px;
    width: 200px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
.note-a{
    cursor: pointer;
    color: cornflowerblue;
    text-decoration: underline;
}
.note-a.on{
    color: #455a64;
}
</style>
<style lang="scss">
.note-input  textarea{
    background-color: #ffffff !important;
    color: #333333 !important;
}
.buy-time{ 
    input{
        background-color: transparent !important;
        width: 60% !important;
    }
}
.buy-time.el-date-editor.el-input, .buy-time.el-date-editor.el-input__inner{
        margin-left: 20px;
    }
</style>